import React, { useState, useEffect } from "react";
import swal from "sweetalert2";
import BotonManualHeader from "../../components/BotonManualHeader";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBin6Fill } from "react-icons/ri";
import {
  FaCloudUploadAlt,
  FaSearch,
  FaUsers,
  FaSyncAlt,
  FaUserPlus,
  FaFileExcel,
  FaFilePdf,
  FaLayerGroup, // ✅ Importar icono de grupos
  FaBan, // ✅ Importar icono de desactivar
  FaBuilding,
  FaKey,
} from "react-icons/fa";
import { BsCheckCircleFill } from "react-icons/bs";
import { BsFillXCircleFill } from "react-icons/bs";

import {
  Container,
  Button,
  Form,
  Table,
  Card,
  Spinner,
  Badge,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import getAllProducts from "../../functions/getAllProducts";
import getReporteDocumentos from "../../functions/getReporteDocumentos";
import { exportarToPDF } from "../../functions/exportarToPDF";
import eliminarUsuario from "../../functions/eliminarUsuario";
import { checkPermission } from "../../functions/checkPermission";
import { useNavigate } from "react-router-dom";

//modales
import ModalAñadir from "../../components/ModalAñadir";
import ModalEditar from "../../components/ModalEditar";
import ModalUpload from "../../components/ModalUpload";
import ModalReporteBoletas from "../../components/ModalReporteBoletas";
import { logBusinessAction } from "../../services/AuditService";

import firebaseApp from "../../firebase/credenciales";
import { collection, doc, getFirestore, writeBatch, getDocs, query, where, orderBy, limit as firestoreLimit, startAfter, getCountFromServer } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import * as XLSX from "xlsx";
import { buildCloudFunctionUrl } from "../../config/firebaseEnv";

const db = getFirestore(firebaseApp);
const functions = getFunctions(firebaseApp, "us-central1");
const auth = getAuth(firebaseApp);

const waitForCurrentUser = async (timeoutMs = 5000) => {
  if (auth.currentUser) return auth.currentUser;

  return await new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      unsubscribe();
      reject(new Error("Sesión no válida. Vuelve a iniciar sesión."));
    }, timeoutMs);

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        clearTimeout(timeout);
        unsubscribe();
        resolve(user);
      }
    });
  });
};

const shouldUseHttpFallback = (error) => {
  const code = String(error?.code || "").toLowerCase();
  const message = String(error?.message || "").toLowerCase();
  return (
    code.includes("internal") ||
    code.includes("unavailable") ||
    message.includes("preflight") ||
    message.includes("cors") ||
    message.includes("fetch")
  );
};

function Usuarios({ usuario }) {
  const navigate = useNavigate();
  const [productos, setProductos] = useState([]);
  const [isModalAñadir, setIsModalAñadir] = useState(false);
  const [isModalEditar, setIsModalEditar] = useState(false);
  const [isModalUpload, setIsModalUpload] = useState(false);
  const [productoEditar, setProductoEditar] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ruc, setRuc] = useState(usuario.ruc);
  const [searchTerm, setSearchTerm] = useState("");
  const baseDatos = "users";

  const [mostrarModalReporte, setMostrarModalReporte] = useState(false);
  const [usuariosSeleccionados, setUsuariosSeleccionados] = useState([]);

  const [todosLosUsuarios, setTodosLosUsuarios] = useState([]);
  const [datosIniciales, setDatosIniciales] = useState(false);
  const [selectAllGlobal, setSelectAllGlobal] = useState(false);
  const [allSelectedUsers, setAllSelectedUsers] = useState([]);

  // ─── Paginación real en Firestore ───────────────────────────────────────────
  const [usuariosPagina, setUsuariosPagina] = useState([]); // Usuarios de la página actual
  const [paginaActual, setPaginaActual] = useState(1);
  const [tamanioPagina, setTamanioPagina] = useState(10);
  const [ultimoDocVisible, setUltimoDocVisible] = useState(null); // Cursor Firestore
  const [hayPaginaSiguiente, setHayPaginaSiguiente] = useState(false);
  const [cursorsPaginas, setCursorsPaginas] = useState([null]); // Cursor por cada página visitada
  const [totalUsuarios, setTotalUsuarios] = useState(0);
  const [totalActivos, setTotalActivos] = useState(0);
  const [totalInactivos, setTotalInactivos] = useState(0);
  const [cargandoPagina, setCargandoPagina] = useState(false);

  // Nuevo estado para controlar el filtro de usuarios
  const [mostrarSoloActivos, setMostrarSoloActivos] = useState(true);

  // ✅ Nuevo estado para grupos
  const [grupos, setGrupos] = useState([]);
  const [cargandoGrupos, setCargandoGrupos] = useState(false);

  // ✅ Nuevo estado para filtro de grupo
  const [grupoSeleccionado, setGrupoSeleccionado] = useState("todos");
  const [cecoSeleccionado, setCecoSeleccionado] = useState("todos");
  const [contratoSeleccionado, setContratoSeleccionado] = useState("todos");

  // ✅ Estado para CECOs
  const [cecos, setCecos] = useState([]);
  const esAdminUsuarios = ["admin", "superAdmin"].includes(String(usuario?.rol || ""));
  const canViewUsuarios = checkPermission(usuario, "usuarios", "USUARIOS") || esAdminUsuarios;
  const canEditUsuarios = checkPermission(usuario, "usuarios", "USUARIOS_EDITAR") || esAdminUsuarios;
  const canDesactivarUsuarios = checkPermission(usuario, "usuarios", "USUARIOS_DESACTIVAR") || esAdminUsuarios;
  const canEliminarMasivoUsuarios = checkPermission(usuario, "usuarios", "USUARIOS_ELIMINAR_MASIVO") || esAdminUsuarios;
  const canResetearClaveUsuarios = checkPermission(usuario, "usuarios", "USUARIOS_RESETEAR_CLAVE") || esAdminUsuarios;
  const canCargaMasivaUsuarios = checkPermission(usuario, "usuarios", "USUARIOS_MASIVOS_CARGA") || esAdminUsuarios;
  const puedeGestionarCampanaClave =
    usuario?.rol === "superAdmin" || usuario?.rol === "admin";

  // ✅ Función para cargar grupos
  const cargarGrupos = async () => {
    if (!ruc) return;

    setCargandoGrupos(true);
    try {
      console.log("🔍 Cargando grupos para RUC:", ruc);

      const gruposRef = collection(db, `grupos/${ruc}/grupos`);
      const snapshot = await getDocs(gruposRef);

      const gruposArray = [];

      snapshot.forEach((doc) => {
        const data = doc.data();
        gruposArray.push({
          id: doc.id,
          name: data.name,
          members: data.members || [],
        });
      });

      // ✅ Ordenar por nombre del grupo
      gruposArray.sort((a, b) => (a.name || "").localeCompare(b.name || ""));

      console.log("📋 Grupos cargados:", gruposArray);

      setGrupos(gruposArray);
    } catch (error) {
      console.error("❌ Error al cargar grupos:", error);
      setGrupos([]);
    } finally {
      setCargandoGrupos(false);
    }
  };

  // ✅ Función para cargar cecos
  const cargarCecos = async () => {
    if (!ruc) return;
    try {
      const cecosRef = collection(db, `cecos/${ruc}/cecos`);
      const snapshot = await getDocs(query(cecosRef, where("activo", "==", true)));
      const cecosArray = [];
      snapshot.forEach((doc) => {
        cecosArray.push({ id: doc.id, ...doc.data() });
      });
      cecosArray.sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
      setCecos(cecosArray);
    } catch (error) {
      console.error("Error al cargar CECOs:", error);
    }
  };

  // ─── Funciones de paginación real en Firestore ─────────────────────────────

  /**
   * Carga una página de usuarios desde Firestore con paginación real.
   * @param {number} tamano - Tamaño de la página
   * @param {object|null} cursorDoc - Documento cursor para startAfter (null = primera página)
   * @returns {Promise<{docs: Array, lastDoc: object, hasMore: boolean}>}
   */
  const cargarPaginaFirestore = async (tamano, cursorDoc = null, soloActivos = true) => {
    const collectionRef = collection(db, baseDatos);
    const constraints = [
      where("rucEmpresa", "==", ruc),
    ];
    if (soloActivos) {
      constraints.push(where("activo", "==", true));
    }
    constraints.push(orderBy("apellidos"));
    constraints.push(firestoreLimit(tamano + 1)); // Pedir 1 extra para detectar si hay más
    if (cursorDoc) {
      constraints.push(startAfter(cursorDoc));
    }
    const q = query(collectionRef, ...constraints);
    const snapshot = await getDocs(q);
    const docs = [];
    let lastDoc = null;
    snapshot.forEach((docSnap) => {
      docs.push({ id: docSnap.id, ...docSnap.data() });
      lastDoc = docSnap;
    });
    const hasMore = docs.length > tamano;
    if (hasMore) docs.pop(); // Quitar el extra
    return { docs, lastDoc, hasMore };
  };

  /**
   * Carga estadísticas usando getCountFromServer (1 lectura por count).
   */
  const cargarEstadisticas = async () => {
    try {
      const collRef = collection(db, baseDatos);
      const qTotal = query(collRef, where("rucEmpresa", "==", ruc));
      const totalSnap = await getCountFromServer(qTotal);
      setTotalUsuarios(totalSnap.data().count);

      const qActivos = query(collRef, where("rucEmpresa", "==", ruc), where("activo", "==", true));
      const activosSnap = await getCountFromServer(qActivos);
      setTotalActivos(activosSnap.data().count);

      setTotalInactivos(totalSnap.data().count - activosSnap.data().count);
    } catch (err) {
      console.error("Error cargando estadísticas:", err);
    }
  };

  /**
   * Carga la primera página y las estadísticas.
   */
  const cargarPrimeraPagina = async () => {
    setCargandoPagina(true);
    try {
      const { docs, lastDoc, hasMore } = await cargarPaginaFirestore(tamanioPagina, null, mostrarSoloActivos);
      setUsuariosPagina(docs);
      setUltimoDocVisible(lastDoc);
      setHayPaginaSiguiente(hasMore);
      setPaginaActual(1);
      setCursorsPaginas([null]);
      setDatosIniciales(true);
    } catch (err) {
      console.error("Error cargando primera página:", err);
    } finally {
      setCargandoPagina(false);
    }
  };

  /**
   * Navega a una página específica usando cursors almacenados.
   */
  const irAPagina = async (numeroPagina) => {
    if (numeroPagina < 1) return;
    if (numeroPagina === paginaActual) return;

    setCargandoPagina(true);
    try {
      if (numeroPagina > paginaActual) {
        // Avanzar: usar el cursor de la página actual
        const { docs, lastDoc, hasMore } = await cargarPaginaFirestore(tamanioPagina, ultimoDocVisible, mostrarSoloActivos);
        setUsuariosPagina(docs);
        setUltimoDocVisible(lastDoc);
        setHayPaginaSiguiente(hasMore);
        setPaginaActual(numeroPagina);
        setCursorsPaginas((prev) => [...prev, lastDoc]);
      } else {
        // Retroceder: recargar desde la primera página hasta la deseada
        let cursor = null;
        for (let i = 1; i < numeroPagina; i++) {
          const { lastDoc } = await cargarPaginaFirestore(tamanioPagina, cursor, mostrarSoloActivos);
          cursor = lastDoc;
        }
        const { docs, lastDoc, hasMore } = await cargarPaginaFirestore(tamanioPagina, cursor, mostrarSoloActivos);
        setUsuariosPagina(docs);
        setUltimoDocVisible(lastDoc);
        setHayPaginaSiguiente(hasMore);
        setPaginaActual(numeroPagina);
        // Reconstruir cursors hasta esta página
        const nuevosCursors = [null];
        let c = null;
        for (let i = 1; i < numeroPagina; i++) {
          const { lastDoc } = await cargarPaginaFirestore(tamanioPagina, c, mostrarSoloActivos);
          c = lastDoc;
          nuevosCursors.push(c);
        }
        setCursorsPaginas([...nuevosCursors, lastDoc]);
      }
    } catch (err) {
      console.error(`Error navegando a página ${numeroPagina}:`, err);
    } finally {
      setCargandoPagina(false);
    }
  };

  /**
   * Cambia el tamaño de página y recarga desde la primera página.
   */
  const cambiarTamanioPagina = async (nuevoTamano) => {
    setTamanioPagina(nuevoTamano);
    setPaginaActual(1);
    setSelectedRows([]);
    setSelectAll(false);
    setSelectAllGlobal(false);
    setAllSelectedUsers([]);
    setCargandoPagina(true);
    try {
      if (nuevoTamano === "todos") {
        // Cargar TODOS los usuarios sin paginación
        const collectionRef = collection(db, baseDatos);
        const constraints = [where("rucEmpresa", "==", ruc)];
        if (mostrarSoloActivos) {
          constraints.push(where("activo", "==", true));
        }
        const q = query(collectionRef, ...constraints);
        const snapshot = await getDocs(q);
        const docs = [];
        snapshot.forEach((docSnap) => {
          docs.push({ id: docSnap.id, ...docSnap.data() });
        });
        setUsuariosPagina(docs);
        setUltimoDocVisible(null);
        setHayPaginaSiguiente(false);
        setCursorsPaginas([null]);
      } else {
        const { docs, lastDoc, hasMore } = await cargarPaginaFirestore(nuevoTamano, null, mostrarSoloActivos);
        setUsuariosPagina(docs);
        setUltimoDocVisible(lastDoc);
        setHayPaginaSiguiente(hasMore);
        setCursorsPaginas([null]);
      }
    } catch (err) {
      console.error("Error cambiando tamaño de página:", err);
    } finally {
      setCargandoPagina(false);
    }
  };

  // ─── Fin funciones de paginación ───────────────────────────────────────────

  // ✅ Función para obtener el grupo de un usuario por DNI
  const obtenerGrupoUsuario = (dni) => {
    const grupo = grupos.find(g => g.members && g.members.includes(dni));
    return grupo ? grupo.name : "Sin grupo";
  };

  const mostrarModalReporteHandler = (usuariosSeleccionados) => {
    setMostrarModalReporte(true);
    setUsuariosSeleccionados(usuariosSeleccionados);
  };

  const onConfirm = async (configuracion) => {
    setLoading(true);
    setMostrarModalReporte(false);
    await exportarAPDF(usuariosSeleccionados, configuracion);
  };

  const handleRowSelection = (rowId) => {
    if (selectedRows.includes(rowId)) {
      if (selectAllGlobal) {
        // Salir del modo "seleccionar todo" y quitar solo el usuario deseleccionado
        const remainingIds = allSelectedUsers
          .map((u) => u.id)
          .filter((id) => id !== rowId);
        setSelectedRows(remainingIds);
        setAllSelectedUsers([]);
        setSelectAllGlobal(false);
        setSelectAll(false);
      } else {
        setSelectedRows(selectedRows.filter((id) => id !== rowId));
      }
    } else {
      setSelectedRows([...selectedRows, rowId]);
      if (selectAllGlobal) {
        setSelectAllGlobal(false);
        setAllSelectedUsers([]);
      }
    }
  };

  const handleDelete = async () => {
    if (!canEliminarMasivoUsuarios) {
      await swal.fire("Acceso restringido", "No tiene permisos para eliminación masiva de usuarios.", "warning");
      return;
    }
    if (selectedRows.length === 0) {
      await swal.fire({
        title: "Sin registros seleccionados",
        text: "Por favor, selecciona al menos un registro para eliminar.",
        icon: "info",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const result = await swal.fire({
      title: "Confirmar eliminación",
      html: `
      <p>¿Estás seguro de que deseas eliminar los registros seleccionados?</p>
      <div class="alert alert-warning">
        <strong>⚠️ Advertencia:</strong><br>
        • Se eliminarán <strong>${selectedRows.length} usuario(s)</strong> de la empresa con RUC: <strong>${ruc}</strong><br>
        • Solo se eliminarán usuarios que pertenezcan a esta empresa<br>
        • <strong>Esta acción NO se puede deshacer</strong>
      </div>
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar definitivamente",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      confirmButtonColor: '#dc3545'
    });

    if (result.isConfirmed) {
      try {
        // Mostrar progreso
        swal.fire({
          title: 'Eliminando usuarios...',
          text: 'Por favor espere',
          allowOutsideClick: false,
          didOpen: () => {
            swal.showLoading();
          }
        });

        // Obtener los usuarios seleccionados y filtrar por rucEmpresa
        const usuariosAEliminar = usuariosPagina
          .filter(producto => selectedRows.includes(producto.id))
          .filter(producto => producto.rucEmpresa === ruc); // ✅ Filtrar por rucEmpresa

        console.log(`Usuarios a eliminar después de filtro: ${usuariosAEliminar.length}`);

        if (usuariosAEliminar.length === 0) {
          swal.close();
          setLoading(false);
          await swal.fire({
            title: "Sin usuarios válidos",
            text: "Ninguno de los usuarios seleccionados pertenece a esta empresa.",
            icon: "warning",
            confirmButtonText: "Aceptar",
          });
          return;
        }

        let eliminados = 0;
        let errores = 0;

        // Crear batch para eliminación
        const batch = writeBatch(db);

        for (const usuario of usuariosAEliminar) {
          try {
            // ✅ Usar el ID del documento (producto.id) - no cambiar a DNI
            const userRef = doc(db, "users", usuario.id);
            batch.delete(userRef);
            eliminados++;

            // Actualizar el título de la alerta existente
            if (swal.isVisible()) {
              swal.update({
                title: `Eliminando... (${eliminados}/${usuariosAEliminar.length})`
              });
            }

          } catch (error) {
            console.error(`Error preparando eliminación del usuario ${usuario.dni}:`, error);
            errores++;
          }
        }

        // Ejecutar el batch
        await batch.commit();

        // Registrar auditoría Opción B
        await logBusinessAction(
          "ELIMINACION_USUARIOS_MASIVA",
          "GestionUsuarios",
          { cantidad: eliminados, rucEmpresa: ruc },
          usuario
        );

        // Cerrar loading
        swal.close();

        if (eliminados > 0) {
          // Actualizar la lista local
          actualizarEstadoProductos(baseDatos, ruc);
          setSelectedRows([]);
          setSelectAll(false);

          await swal.fire({
            title: "Eliminación completada",
            html: `
            <div class="text-success">
              <strong>✅ ${eliminados} usuario(s) eliminado(s) correctamente</strong>
            </div>
            ${errores > 0 ? `
              <div class="text-warning mt-2">
                <strong>⚠️ ${errores} usuario(s) con errores</strong>
              </div>
            ` : ''}
          `,
            icon: eliminados === usuariosAEliminar.length ? "success" : "warning",
            confirmButtonText: "Aceptar",
          });
        } else {
          await swal.fire({
            title: "Error en eliminación",
            text: "No se pudo eliminar ningún usuario. Revise la consola para más detalles.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        }

      } catch (error) {
        console.error("Error general al eliminar usuarios:", error);
        await swal.fire({
          title: "Error",
          text: "Hubo un error al eliminar los usuarios. Intente nuevamente.",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      }
    }
  };



  const handleSelectAll = async () => {
    if (selectAll) {
      setSelectedRows([]);
      setSelectAllGlobal(false);
      setAllSelectedUsers([]);
    } else {
      // Cargar TODOS los IDs de usuarios desde Firestore (no solo la página actual)
      try {
        const collectionRef = collection(db, baseDatos);
        const constraints = [where("rucEmpresa", "==", ruc)];
        if (mostrarSoloActivos) {
          constraints.push(where("activo", "==", true));
        }
        const q = query(collectionRef, ...constraints);
        const snapshot = await getDocs(q);
        const allIds = [];
        const users = [];
        snapshot.forEach((docSnap) => {
          allIds.push(docSnap.id);
          users.push({ id: docSnap.id, ...docSnap.data() });
        });
        setSelectedRows(allIds);
        setAllSelectedUsers(users);
        setSelectAllGlobal(true);
      } catch (err) {
        console.error("Error cargando todos los usuarios para selección:", err);
      }
    }
    setSelectAll(!selectAll);
  };

  function exportarExcel(usuariosSeleccionados) {
    setLoading(true);

    const usuariosParaExcel = usuariosSeleccionados.map((u) => ({
      DNI: u.dni || "",
      Legajo: u.legajo || "",
      Legajo2: u.legajo2 || "",
      Nombres: u.name || "",
      Apellidos: u.apellidos || "",
      Email: u.email || "",
      Celular: u.phone || "",
      Cargo: u.cargo || "",
      CECO: u.cecoNombre || "Sin CECO",
      Grupo: obtenerGrupoUsuario(u.dni),
      Contrato: u.contrato || "",
      Estado: u.activo === true ? "Activo" : "Inactivo",
      Direccion: u.direccion || "",
      Vacaciones: u.vacaciones || 0,
    }));

    const sheet = XLSX.utils.json_to_sheet(usuariosParaExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, "Usuarios");
    XLSX.writeFile(workbook, "usuarios.xlsx");
    setLoading(false);
  }

  async function busquedaFormHandler(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const busqueda = e.target.busqueda.value.trim().toLowerCase();

      if (busqueda === "") {
        // Sin búsqueda: recargar primera página
        await cargarPrimeraPagina();
        setLoading(false);
        return;
      }

      // Intentar búsqueda por DNI exacto en Firestore (1 lectura)
      const collectionRef = collection(db, baseDatos);
      const q = query(collectionRef, where("rucEmpresa", "==", ruc), where("dni", "==", busqueda));
      const snap = await getDocs(q);

      if (!snap.empty) {
        const resultados = [];
        snap.forEach((docSnap) => resultados.push({ id: docSnap.id, ...docSnap.data() }));
        setUsuariosPagina(resultados);
        setPaginaActual(1);
        setHayPaginaSiguiente(false);
        setLoading(false);
        return;
      }

      // Fallback: cargar todos los usuarios y filtrar en JavaScript
      // (necesario para búsquedas parciales de nombre/apellido que Firestore no soporta)
      if (todosLosUsuarios.length === 0) {
        const todos = await getAllProducts(baseDatos, ruc);
        setTodosLosUsuarios(todos);
      }

      const usuariosParaBuscar = todosLosUsuarios.length > 0 ? todosLosUsuarios : await getAllProducts(baseDatos, ruc);
      const filtrados = usuariosParaBuscar.filter((usuario) => {
        const dni = usuario.dni?.toString().toLowerCase() || "";
        const nombres = usuario.name?.toLowerCase() || "";
        const apellidos = usuario.apellidos?.toLowerCase() || "";
        const nombresArray = nombres.split(" ");
        const apellidosArray = apellidos.split(" ");
        return (
          dni.includes(busqueda) ||
          nombresArray.some((nom) => nom.includes(busqueda)) ||
          apellidosArray.some((ap) => ap.includes(busqueda))
        );
      });

      setUsuariosPagina(filtrados);
      setPaginaActual(1);
      setHayPaginaSiguiente(false);
      setLoading(false);

      if (filtrados.length === 0) {
        await swal.fire({
          title: "Usuario no encontrado",
          text: `No se encontró ningún usuario que coincida con "${busqueda}". Verifique el DNI, nombre o apellido e intente nuevamente.`,
          icon: "info",
          confirmButtonText: "Aceptar",
        });
      }
    } catch (error) {
      console.error("Error en la búsqueda:", error);
      setLoading(false);
      swal.fire({
        title: "Error",
        text: "Hubo un error al realizar la búsqueda",
        icon: "error",
      });
    }
  }

  const limpiarBusqueda = () => {
    const input = document.getElementById("busqueda");
    if (input) input.value = "";
    setSearchTerm("");
    setSelectedRows([]);
    setSelectAll(false);
    setSelectAllGlobal(false);
    setAllSelectedUsers([]);
    // Recargar primera página paginada
    cargarPrimeraPagina();
  };

  // Filtrar productos de la PÁGINA ACTUAL por término de búsqueda Y por grupo
  // NOTA: El filtro de activo/inactivo ya se hace en Firestore (where activo == true)
  const productosFiltrados = usuariosPagina.filter((producto) => {
    const cumpleBusqueda =
      producto.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      producto.apellidos?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      producto.dni?.toString().includes(searchTerm) ||
      producto.email?.toLowerCase().includes(searchTerm.toLowerCase());

    // ✅ Nuevo filtro por grupo
    const cumpleGrupo = grupoSeleccionado === "todos" ||
      (grupoSeleccionado === "sin_grupo" && obtenerGrupoUsuario(producto.dni) === "Sin grupo") ||
      obtenerGrupoUsuario(producto.dni) === grupos.find(g => g.id === grupoSeleccionado)?.name;

    const cecoNombre = String(producto.cecoNombre || "").trim();
    const cumpleCeco =
      cecoSeleccionado === "todos" ||
      (cecoSeleccionado === "sin_ceco" && !cecoNombre) ||
      cecoNombre === cecoSeleccionado;

    const contrato = String(producto.contrato || "").trim().toUpperCase();
    const cumpleContrato =
      contratoSeleccionado === "todos" ||
      (contratoSeleccionado === "sin_contrato" && !contrato) ||
      contrato === contratoSeleccionado;

    return cumpleBusqueda && cumpleGrupo && cumpleCeco && cumpleContrato;
  });

  const contratosDisponibles = [...new Set(
    usuariosPagina
      .map((u) => String(u.contrato || "").trim().toUpperCase())
      .filter(Boolean)
  )].sort((a, b) => a.localeCompare(b));

  // Funciones para calcular estadísticas (usando contadores de Firestore, NO el array completo)
  const calcularUsuariosActivos = () => totalActivos;
  const calcularUsuariosInactivos = () => totalInactivos;
  const calcularUsuariosSinEstado = () => totalUsuarios - totalActivos - totalInactivos;

  // Función para alternar el filtro — recarga la primera página con el nuevo filtro
  const toggleMostrarUsuarios = () => {
    setMostrarSoloActivos(!mostrarSoloActivos);
    setSelectedRows([]); // Limpiar selecciones al cambiar filtro
    setSelectAll(false);
    setSelectAllGlobal(false);
    setAllSelectedUsers([]);
    // Recargar primera página con el filtro invertido
    // Usamos !mostrarSoloActivos porque el state aún no se actualizó
    setCargandoPagina(true);
    const nuevoFiltro = !mostrarSoloActivos;
    cargarPaginaFirestore(tamanioPagina, null, nuevoFiltro)
      .then(({ docs, lastDoc, hasMore }) => {
        setUsuariosPagina(docs);
        setUltimoDocVisible(lastDoc);
        setHayPaginaSiguiente(hasMore);
        setPaginaActual(1);
        setCursorsPaginas([null]);
      })
      .catch((err) => console.error("Error recargando con filtro:", err))
      .finally(() => setCargandoPagina(false));
  };

  const limpiarFiltrosCatalogo = () => {
    setGrupoSeleccionado("todos");
    setCecoSeleccionado("todos");
    setContratoSeleccionado("todos");
  };

  function actualizarEstadoProductos(db, ruc) {
    // Cargar primera página paginada + estadísticas (NO descarga todos los usuarios)
    Promise.all([
      cargarPrimeraPagina(),
      cargarEstadisticas(),
    ]);
  }

  React.useEffect(() => {
    actualizarEstadoProductos(baseDatos, ruc);
  }, [ruc]);

  function añadirProductoHome() {
    if (!canEditUsuarios) {
      swal.fire("Acceso restringido", "No tiene permisos para crear usuarios.", "warning");
      return;
    }
    setIsModalAñadir(true);
  }

  // ✅ useEffect para cargar grupos y CECOs cuando se monta el componente
  useEffect(() => {
    if (ruc) {
      cargarGrupos();
      cargarCecos();
    }
  }, [ruc]);

  async function exportarAPDF(usuariosSeleccionados, configuracion) {
    try {
      const ano = configuracion.ano;
      const periodoInicio = configuracion.periodoInicio;
      const periodoFin = configuracion.periodoFin;
      const tipoDocumento = configuracion.tipoDocumento;
      const incluirTodosLosUsuarios =
        configuracion.incluirTodosLosUsuarios;

      // La capa unificada consulta `document`, `uploadDocument` y el grupo de
      // colecciones `legajo` (contratos, adendas y examen médico), de modo que
      // el reporte cubre todos los tipos de documento gestionados.
      const registros = await getReporteDocumentos({
        ruc,
        ano,
        periodoInicio,
        periodoFin,
        tipoDocumento,
        incluirTodos: incluirTodosLosUsuarios,
        dniList: (usuariosSeleccionados || [])
          .map((usuario) => usuario?.dni)
          .filter(Boolean),
      });

      if (registros.length === 0) {
        swal.fire({
          title: "Sin datos",
          text: `No se encontraron documentos de tipo "${tipoDocumento}" con los criterios seleccionados.`,
          icon: "info",
          confirmButtonText: "Aceptar",
        });
        setLoading(false);
        return;
      }

      const pdfBytes = await exportarToPDF(registros, ruc);

      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      const fecha = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);
      const tipoReporte = incluirTodosLosUsuarios
        ? "completo"
        : "seleccionados";
      a.download = `reporte_${tipoReporte}_${fecha}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Se libera la URL en el siguiente ciclo para no cancelar la descarga.
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      setLoading(false);

      swal.fire({
        title: "Reporte generado",
        text: `Se ha generado el reporte con ${registros.length} documento(s).`,
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al exportar a PDF:", error);
      setLoading(false);
      const errorCode = String(error?.code || "").toLowerCase();
      const errorMessage = String(error?.message || "").toLowerCase();
      const isQuotaExceeded =
        errorCode.includes("resource-exhausted") ||
        errorMessage.includes("quota exceeded");

      swal.fire({
        title: "Error",
        text: isQuotaExceeded
          ? "La cuota de Firestore está agotada temporalmente. Intente nuevamente más tarde o reduzca el rango del reporte."
          : "Hubo un error al generar el reporte. Por favor, inténtalo de nuevo.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  }

  const modalProps = {
    isModalAñadir,
    setIsModalAñadir,
    actualizarEstadoProductos,
    usuario,
    cecos,
    crearConFirebaseUid: true,
    // El alta se hace por la Cloud Function `crearUsuario`: las reglas de
    // Firestore solo permiten `create` en `users` a los administradores de
    // plataforma, y los roles con `USUARIOS_EDITAR` (asistente, rh…) recibían
    // «Missing or insufficient permissions.» al escribir desde el cliente.
    usarCrearUsuario: true,
  };

  const modalEditProps = {
    isModalEditar,
    setIsModalEditar,
    actualizarEstadoProductos,
    productoEditar,
    setProductoEditar,
    usuario,
    cecos,
    contratos: contratosDisponibles,
  };

  const modalUploadProps = {
    isModalUpload,
    setIsModalUpload,
    actualizarEstadoProductos,
    productoEditar,
    setProductoEditar,
  };

  const modalReporteProps = {
    mostrar: mostrarModalReporte,
    onClose: () => setMostrarModalReporte(false),
    onConfirm: onConfirm,
    usuariosSeleccionados: usuariosSeleccionados,
    ruc: ruc, // ✅ Pasar ruc al modal
  };

  const getSelectedUsers = () => {
    if (selectAllGlobal && allSelectedUsers.length > 0) {
      return allSelectedUsers;
    }
    return usuariosPagina.filter((producto) => selectedRows.includes(producto.id));
  };

  const resetearClaveUsuario = async (producto) => {
    if (!canResetearClaveUsuarios) {
      await swal.fire("Acceso restringido", "No tiene permisos para resetear claves.", "warning");
      return;
    }
    const email = String(producto?.email || "").trim().toLowerCase();
    const dni = String(producto?.dni || "").trim();
    if (!email || !dni) {
      await swal.fire("Datos incompletos", "El usuario no tiene email o DNI válido.", "warning");
      return;
    }

    const prompt = await swal.fire({
      title: "Resetear contraseña",
      html: `
        <p class="mb-2"><strong>Usuario:</strong> ${producto?.name || ""} ${producto?.apellidos || ""}</p>
        <p class="mb-2"><strong>Email:</strong> ${email}</p>
        <p class="mb-3">Deja vacío para usar el DNI como nueva contraseña.</p>
        <input id="new-password-input" class="swal2-input" placeholder="Nueva contraseña (opcional)" />
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Resetear",
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const v = document.getElementById("new-password-input")?.value || "";
        if (v && v.trim().length < 6) {
          swal.showValidationMessage("Si define una clave manual, debe tener al menos 6 caracteres.");
          return false;
        }
        return v.trim();
      }
    });

    if (!prompt.isConfirmed) return;

    const newPassword = prompt.value || dni;

    try {
      setLoading(true);
      const currentUser = await waitForCurrentUser();
      const idToken = await currentUser.getIdToken(true);
      const callable = httpsCallable(functions, "resetUserPassword");
      try {
        await callable({ email, dni, newPassword, idToken });
      } catch (callableError) {
        if (!shouldUseHttpFallback(callableError)) {
          throw callableError;
        }

        const httpUrl = buildCloudFunctionUrl("resetUserPasswordHttp");
        const response = await fetch(httpUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({ email, dni, newPassword, idToken }),
        });

        const responseJson = await response.json().catch(() => ({}));
        if (!response.ok || responseJson?.success === false) {
          throw new Error(
            responseJson?.message || `No se pudo resetear la contraseña (HTTP ${response.status}).`
          );
        }
      }

      setLoading(false);
      await swal.fire("Éxito", `Contraseña restablecida para ${email}.`, "success");
    } catch (error) {
      console.error("Error al resetear contraseña:", error);
      setLoading(false);
      await swal.fire("Error", error?.message || "No se pudo resetear la contraseña.", "error");
    } finally {
      setLoading(false);
    }
  };

  const forzarCambioSoloNoLogueados = async () => {
    if (!ruc) {
      await swal.fire("RUC no disponible", "No se encontró el RUC de la empresa actual.", "warning");
      return;
    }

    const confirm = await swal.fire({
      title: "Forzar cambio de contraseña",
      html: `
        <p>Se marcará <strong>solo</strong> a usuarios que aún no iniciaron sesión.</p>
        <p class="mb-0"><strong>Empresa:</strong> ${ruc}</p>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ejecutar campaña",
      cancelButtonText: "Cancelar",
    });

    if (!confirm.isConfirmed) return;

    try {
      setLoading(true);
      const currentUser = await waitForCurrentUser();
      const idToken = await currentUser.getIdToken(true);
      const callable = httpsCallable(functions, "markMustChangePasswordForPendingFirstLogin");
      const response = await callable({ rucEmpresa: ruc, idToken });
      const data = response?.data || {};

      setLoading(false);
      await swal.fire({
        title: "Campaña ejecutada",
        icon: "success",
        html: `
          <div style="text-align:left">
            <p><strong>Evaluados:</strong> ${data.evaluated || 0}</p>
            <p><strong>Marcados para cambio:</strong> ${data.marked || 0}</p>
            <p><strong>Omitidos (ya ingresaron):</strong> ${data.alreadySignedIn || 0}</p>
            <p><strong>Errores:</strong> ${(data.errors || []).length}</p>
          </div>
        `,
      });
    } catch (error) {
      console.error("Error en campaña de forzado:", error);
      setLoading(false);
      await swal.fire("Error", error?.message || "No se pudo ejecutar la campaña.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium con degradado azul para Gestión de Usuarios */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
              borderBottom: "3px solid #f59e0b",
            }}
          >
            <div className="position-absolute end-0 top-50 translate-middle-y me-4" style={{ zIndex: 10 }}>
              <BotonManualHeader />
            </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaUsers className="me-3" />
                Gestión de Usuarios
              </h2>
              <p className="mb-0 opacity-75">
                Administra los usuarios y empleados del sistema
              </p>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Indicador de carga inicial */}
            {!datosIniciales && usuariosPagina.length === 0 && !loading && (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="text-muted mt-3 mb-0">Cargando usuarios...</p>
              </div>
            )}

            {/* Indicador de carga para operaciones */}
            {loading && (
              <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75"
                style={{ zIndex: 1080 }}
              >
                <div className="text-center">
                  <Spinner
                    animation="border"
                    variant="light"
                    style={{ width: "3rem", height: "3rem" }}
                  />
                  <p className="text-white mt-3 mb-0">
                    Procesando solicitud...
                  </p>
                </div>
              </div>
            )}

            {/* Modales */}
            <ModalAñadir {...modalProps} />
            {productoEditar && <ModalEditar {...modalEditProps} />}
            {productoEditar && <ModalUpload {...modalUploadProps} />}
            <ModalReporteBoletas {...modalReporteProps} />

            {/* Contenido principal */}
            {!canViewUsuarios && (
              <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "15px" }}>
                <Card.Body className="text-center py-5">
                  <h5 className="text-muted mb-2">Acceso restringido</h5>
                  <p className="text-muted mb-0">No tiene permisos para acceder a la lista de usuarios.</p>
                </Card.Body>
              </Card>
            )}
            {datosIniciales && canViewUsuarios && (
              <>
                {/* Barra superior con acciones */}
                <Card
                  className="shadow-sm border-0 mb-4"
                  style={{ borderRadius: "15px" }}
                >
                  <Card.Body className="p-4">
                    <Row className="align-items-center">
                      <Col md={1}>
                        <div
                          className="rounded-3 p-3 text-center"
                          style={{
                            background:
                              "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                            color: "white",
                          }}
                        >
                          <FaUsers size={24} />
                        </div>
                      </Col>
                      <Col md={7}>
                        <h5 className="mb-1 fw-semibold">
                          Gestión de Usuarios
                        </h5>
                        <p className="text-muted mb-0 small">
                          Administra empleados, perfiles y permisos del sistema
                        </p>
                      </Col>
                      <Col md={4} className="text-end">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>Agregar nuevo usuario</Tooltip>}
                        >
                          <Button
                            variant="light"
                            className="d-flex align-items-center gap-2"
                            onClick={añadirProductoHome}
                            style={{
                              borderRadius: "10px",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <FaUserPlus size="16px" />
                            Nuevo Usuario
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* Barra de búsqueda mejorada */}
                <Card
                  className="shadow-sm border-0 mb-4"
                  style={{ borderRadius: "15px" }}
                >
                  <Card.Body className="p-3">
                    <Form onSubmit={busquedaFormHandler}>
                      <Row className="g-2 align-items-center">
                        <Col md={8}>
                          <div className="position-relative">
                            <FaSearch
                              className="position-absolute"
                              style={{
                                left: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#6c757d",
                                zIndex: 2,
                              }}
                            />
                            <Form.Control
                              id="busqueda"
                              type="text"
                              placeholder="Buscar usuarios por DNI, nombres, apellidos o correo..."
                              className="form-control-lg ps-5"
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              style={{
                                borderRadius: "10px",
                                border: "2px solid #e9ecef",
                              }}
                            />
                          </div>
                        </Col>
                        <Col md={2}>
                          <Button
                            variant="primary"
                            type="submit"
                            className="w-100 d-flex align-items-center justify-content-center gap-2"
                            size="lg"
                            style={{
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                              border: "none",
                            }}
                          >
                            <FaSearch size="16px" />
                            Buscar
                          </Button>
                        </Col>
                        <Col md={2}>
                          <Button
                            variant="outline-secondary"
                            size="lg"
                            className="w-100 d-flex align-items-center justify-content-center gap-2"
                            onClick={limpiarBusqueda}
                            style={{ borderRadius: "10px" }}
                          >
                            <FaSyncAlt size="16px" />
                            Limpiar
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>

                {/* Filtro de usuarios activos/todos y filtros por catálogo */}
                <Card
                  className="shadow-sm border-0 mb-4"
                  style={{
                    borderRadius: "18px",
                    background:
                      "linear-gradient(135deg, #eef4ff 0%, #f8fbff 55%, #ffffff 100%)",
                    boxShadow: "0 12px 30px rgba(30, 58, 138, 0.08)",
                  }}
                >
                  <Card.Body className="p-4">
                    <Row className="align-items-center">
                      <Col md={6}>
                        <div className="d-flex align-items-center gap-3">
                          <div className="d-flex align-items-center gap-2">
                            <div
                              className="rounded-2 p-2"
                              style={{
                                background: mostrarSoloActivos
                                  ? "linear-gradient(135deg, #059669 0%, #10b981 100%)"
                                  : "linear-gradient(135deg, #6b7280 0%, #9ca3af 100%)",
                                color: "white",
                              }}
                            >
                              <FaUsers size={16} />
                            </div>
                            <div>
                              <h6 className="mb-0 fw-semibold">
                                {mostrarSoloActivos ? "Usuarios Activos" : "Todos los Usuarios"}
                              </h6>
                              <small className="text-muted">
                                {mostrarSoloActivos
                                  ? "Mostrando solo usuarios habilitados"
                                  : "Mostrando usuarios activos e inactivos"}
                              </small>
                            </div>
                          </div>
                          <Badge
                            bg={mostrarSoloActivos ? "success" : "secondary"}
                            className="px-3 py-2"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {productosFiltrados.length} usuarios mostrados
                          </Badge>
                        </div>
                      </Col>
                      <Col md={3} className="text-center">
                        <Button
                          variant={mostrarSoloActivos ? "outline-secondary" : "outline-success"}
                          onClick={toggleMostrarUsuarios}
                          className="d-flex align-items-center gap-2"
                          style={{
                            borderRadius: "10px",
                            padding: "8px 16px",
                            fontWeight: "500"
                          }}
                        >
                          <FaUsers size="14px" />
                          {mostrarSoloActivos ? "Ver Todos" : "Solo Activos"}
                        </Button>
                      </Col>
                    </Row>
                    <Row className="mt-3 g-3">
                      <Col md={4}>
                        <Form.Group
                          className="p-3 h-100"
                          style={{
                            borderRadius: "14px",
                            background: "rgba(255,255,255,0.85)",
                            border: "1px solid rgba(59, 130, 246, 0.18)",
                          }}
                        >
                          <Form.Label className="d-flex align-items-center gap-2 fw-semibold text-primary mb-2">
                            <FaLayerGroup size={14} />
                            <span>Grupo</span>
                          </Form.Label>
                          <Form.Select
                            value={grupoSeleccionado}
                            onChange={(e) => setGrupoSeleccionado(e.target.value)}
                            className="form-select shadow-sm"
                            disabled={cargandoGrupos}
                            style={{
                              borderRadius: "10px",
                              border: "1px solid #93c5fd",
                              backgroundColor: "#fff",
                            }}
                          >
                            <option value="todos">
                              {cargandoGrupos ? "Cargando grupos..." : "Todos los grupos"}
                            </option>
                            <option value="sin_grupo">Sin grupo</option>
                            {grupos.map((grupo) => (
                              <option key={grupo.id} value={grupo.id}>
                                {grupo.name} ({grupo.members?.length || 0} miembro{grupo.members?.length !== 1 ? "s" : ""})
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group
                          className="p-3 h-100"
                          style={{
                            borderRadius: "14px",
                            background: "rgba(255,255,255,0.85)",
                            border: "1px solid rgba(59, 130, 246, 0.18)",
                          }}
                        >
                          <Form.Label className="d-flex align-items-center gap-2 fw-semibold text-primary mb-2">
                            <FaBuilding size={13} />
                            <span>CECO</span>
                          </Form.Label>
                          <Form.Select
                            value={cecoSeleccionado}
                            onChange={(e) => setCecoSeleccionado(e.target.value)}
                            className="form-select shadow-sm"
                            style={{
                              borderRadius: "10px",
                              border: "1px solid #93c5fd",
                              backgroundColor: "#fff",
                            }}
                          >
                            <option value="todos">Todos los CECO</option>
                            <option value="sin_ceco">Sin CECO</option>
                            {cecos.map((ceco) => (
                              <option key={ceco.id} value={ceco.nombre || ""}>
                                {ceco.nombre || ceco.id}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group
                          className="p-3 h-100"
                          style={{
                            borderRadius: "14px",
                            background: "rgba(255,255,255,0.85)",
                            border: "1px solid rgba(59, 130, 246, 0.18)",
                          }}
                        >
                          <Form.Label className="d-flex align-items-center gap-2 fw-semibold text-primary mb-2">
                            <FaUsers size={13} />
                            <span>Tipo de contrato</span>
                          </Form.Label>
                          <Form.Select
                            value={contratoSeleccionado}
                            onChange={(e) => setContratoSeleccionado(e.target.value)}
                            className="form-select shadow-sm"
                            style={{
                              borderRadius: "10px",
                              border: "1px solid #93c5fd",
                              backgroundColor: "#fff",
                            }}
                          >
                            <option value="todos">Todos los contratos</option>
                            <option value="sin_contrato">Sin contrato</option>
                            {contratosDisponibles.map((contrato) => (
                              <option key={contrato} value={contrato}>
                                {contrato}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col className="text-end">
                        <Button
                          variant="light"
                          size="sm"
                          onClick={limpiarFiltrosCatalogo}
                          className="d-inline-flex align-items-center gap-2"
                          style={{
                            borderRadius: "999px",
                            border: "1px solid #bfdbfe",
                            color: "#1e3a8a",
                            fontWeight: 600,
                            padding: "8px 14px",
                          }}
                        >
                          <FaSyncAlt size={12} />
                          Limpiar filtros
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* Estadísticas */}
                <Row className="mb-4">
                  <Col md={3}>
                    <Card
                      className="border-0 shadow-sm"
                      style={{ borderRadius: "15px" }}
                    >
                      <Card.Body
                        className="text-center"
                        style={{
                          background:
                            "linear-gradient(135deg, #059669 0%, #10b981 100%)",
                          color: "white",
                          borderRadius: "15px",
                        }}
                      >
                        <h4 className="fw-bold">
                          {calcularUsuariosActivos()}
                        </h4>
                        <p className="mb-0">Usuarios Activos</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card
                      className="border-0 shadow-sm"
                      style={{ borderRadius: "15px" }}
                    >
                      <Card.Body
                        className="text-center"
                        style={{
                          background:
                            "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
                          color: "white",
                          borderRadius: "15px",
                        }}
                      >
                        <h4 className="fw-bold">
                          {calcularUsuariosInactivos()}
                        </h4>
                        <p className="mb-0">Usuarios Inactivos</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card
                      className="border-0 shadow-sm"
                      style={{ borderRadius: "15px" }}
                    >
                      <Card.Body
                        className="text-center"
                        style={{
                          background:
                            "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                          color: "white",
                          borderRadius: "15px",
                        }}
                      >
                        <h4 className="fw-bold">{totalUsuarios}</h4>
                        <p className="mb-0">Total Usuarios</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={3}>
                    <Card
                      className="border-0 shadow-sm"
                      style={{ borderRadius: "15px" }}
                    >
                      <Card.Body
                        className="text-center"
                        style={{
                          background:
                            "linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)",
                          color: "white",
                          borderRadius: "15px",
                        }}
                      >
                        <h4 className="fw-bold">{grupos.length}</h4>
                        <p className="mb-0">Grupos</p>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* Mensaje cuando no hay usuarios después de búsqueda */}
                {productosFiltrados.length === 0 && (
                  <Card
                    className="border-0 shadow-sm mb-4"
                    style={{ borderRadius: "15px" }}
                  >
                    <Card.Body className="text-center py-5">
                      <div
                        className="bg-light rounded-circle mx-auto mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaUsers size={32} className="text-muted" />
                      </div>
                      <h5 className="text-muted mb-2">
                        {mostrarSoloActivos ? "No hay usuarios activos" : "No hay usuarios disponibles"}
                      </h5>
                      <p className="text-muted mb-3">
                        {searchTerm
                          ? `No se encontraron usuarios ${mostrarSoloActivos ? 'activos' : ''} que coincidan con tu búsqueda`
                          : mostrarSoloActivos
                            ? "No hay usuarios activos en el sistema"
                            : "Agrega tu primer usuario haciendo clic en 'Nuevo Usuario'"}
                      </p>
                      <div className="d-flex gap-2 justify-content-center">
                        {searchTerm && (
                          <Button
                            variant="outline-secondary"
                            onClick={limpiarBusqueda}
                            className="d-flex align-items-center gap-2"
                            style={{ borderRadius: "10px" }}
                          >
                            <FaSyncAlt size="14px" />
                            Limpiar búsqueda
                          </Button>
                        )}
                        {mostrarSoloActivos && calcularUsuariosInactivos() > 0 && (
                          <Button
                            variant="outline-info"
                            onClick={toggleMostrarUsuarios}
                            className="d-flex align-items-center gap-2"
                            style={{ borderRadius: "10px" }}
                          >
                            <FaUsers size="14px" />
                            Ver todos los usuarios
                          </Button>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                )}

                {/* Tabla de usuarios */}
                {productosFiltrados.length > 0 && (
                  <Card
                    className="border-0 shadow-sm mb-4"
                    style={{ borderRadius: "15px" }}
                  >
                    <Card.Header
                      className="text-white py-3"
                      style={{
                        background:
                          "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                        borderRadius: "15px 15px 0 0",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <FaUsers className="me-2" />
                        <div className="flex-grow-1">
                          <h5 className="mb-0 fw-semibold">
                            Lista de Usuarios {mostrarSoloActivos ? "Activos" : ""}
                          </h5>
                          <small className="opacity-75">
                            {mostrarSoloActivos
                              ? "Usuarios habilitados en el sistema"
                              : "Gestiona todos los usuarios del sistema"}
                          </small>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <Badge
                            bg="light"
                            text="dark"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {productosFiltrados.length} usuarios
                          </Badge>
                          <Badge
                            bg={mostrarSoloActivos ? "success" : "secondary"}
                            style={{ fontSize: "0.8rem" }}
                          >
                            {mostrarSoloActivos ? "Solo Activos" : "Todos"}
                          </Badge>
                        </div>
                      </div>
                    </Card.Header>

                    <Card.Body className="p-0">
                      <div style={{ maxHeight: "600px", overflowY: "auto" }}>
                        <Table
                          hover
                          responsive
                          className="mb-0"
                          style={{ fontSize: "0.9rem" }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#f8f9fa",
                              position: "sticky",
                              top: 0,
                              zIndex: 10,
                            }}
                          >
                            <tr>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                                style={{ width: "4%" }}
                              >
                                <div className="form-check mb-0">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={selectAll}
                                    onChange={handleSelectAll}
                                  />
                                </div>
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                                style={{ width: "4%" }}
                              >
                                #
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                                style={{ width: "6%" }}
                              >
                                Estado
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold"
                                style={{ width: "12%" }}
                              >
                                DNI
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                                style={{ width: "6%" }}
                              >
                                Tipo
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold"
                                style={{ width: "22%" }}
                              >
                                Nombres
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold"
                                style={{ width: "22%" }}
                              >
                                Apellidos
                              </th>
                              {/* ✅ Nueva columna Grupo */}
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                                style={{ width: "16%" }}
                              >
                                <FaLayerGroup className="me-1" />
                                Grupo
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                                style={{ width: "16%" }}
                              >
                                <FaBuilding className="me-1" />
                                CECO
                              </th>
                              <th
                                className="border-0 py-3 px-3 text-secondary fw-semibold text-center"
                                style={{ width: "20%" }}
                              >
                                Acciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {productosFiltrados.map((producto, index) => (
                              <tr
                                key={producto.id}
                                style={{ borderBottom: "1px solid #f1f3f4" }}
                              >
                                <td className="text-center py-3 px-3">
                                  <div className="form-check mb-0">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={selectedRows.includes(
                                        producto.id
                                      )}
                                      onChange={() =>
                                        handleRowSelection(producto.id)
                                      }
                                    />
                                  </div>
                                </td>
                                <td className="text-center py-3 px-3">
                                  <Badge
                                    bg="dark"
                                    className="px-2 py-1"
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    {index + 1}
                                  </Badge>
                                </td>
                                <td className="text-center py-3 px-3">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {producto.activo === true
                                          ? "Usuario Activo"
                                          : producto.activo === false
                                            ? "Usuario Inactivo"
                                            : "Estado no definido"}
                                      </Tooltip>
                                    }
                                  >
                                    {producto.activo === true ? (
                                      <span>
                                        <BsCheckCircleFill
                                          size="18px"
                                          className="text-success"
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    ) : producto.activo === false ? (
                                      <span>
                                        <BsFillXCircleFill
                                          size="18px"
                                          className="text-danger"
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    ) : (
                                      <Badge bg="warning" text="dark">
                                        ?
                                      </Badge>
                                    )}
                                  </OverlayTrigger>
                                </td>
                                <td className="py-3 px-3">
                                  <Badge
                                    bg="secondary"
                                    className="px-2 py-1"
                                    style={{ fontSize: "0.75rem" }}
                                  >
                                    {producto.dni}
                                  </Badge>
                                </td>
                                <td className="text-center py-3 px-3">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>{producto.contrato}</Tooltip>
                                    }
                                  >
                                    <Badge
                                      bg="info"
                                      className="px-1 py-1"
                                      style={{
                                        fontSize: "0.7rem",
                                        cursor: "pointer",
                                        minWidth: "40px",
                                      }}
                                    >
                                      {producto.contrato?.substring(0, 3)}
                                    </Badge>
                                  </OverlayTrigger>
                                </td>
                                <td className="py-3 px-3">
                                  <div className="fw-medium text-dark">
                                    {producto.name}
                                  </div>
                                </td>
                                <td className="py-3 px-3 fw-medium text-dark">
                                  {producto.apellidos}
                                </td>
                                {/* ✅ Nueva celda Grupo */}
                                <td className="text-center py-3 px-3">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {obtenerGrupoUsuario(producto.dni)}
                                      </Tooltip>
                                    }
                                  >
                                    <Badge
                                      bg={obtenerGrupoUsuario(producto.dni) === "Sin grupo" ? "light" : "primary"}
                                      text={obtenerGrupoUsuario(producto.dni) === "Sin grupo" ? "dark" : "white"}
                                      className="px-2 py-1"
                                      style={{ fontSize: "0.7rem", cursor: "pointer" }}
                                    >
                                      <FaLayerGroup className="me-1" size="10px" />
                                      {obtenerGrupoUsuario(producto.dni).length > 30
                                        ? obtenerGrupoUsuario(producto.dni).substr(0, 30) + "..."
                                        : obtenerGrupoUsuario(producto.dni)}
                                    </Badge>
                                  </OverlayTrigger>
                                </td>
                                <td className="text-center py-3 px-3">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {producto.cecoNombre || "Sin CECO"}
                                      </Tooltip>
                                    }
                                  >
                                    <Badge
                                      bg={producto.cecoNombre ? "info" : "light"}
                                      text={producto.cecoNombre ? "white" : "dark"}
                                      className="px-2 py-1 border border-1"
                                      style={{ fontSize: "0.7rem", cursor: "pointer", borderColor: "#dee2e6" }}
                                    >
                                      {producto.cecoNombre?.length > 25
                                        ? producto.cecoNombre.substr(0, 25) + "..."
                                        : (producto.cecoNombre || "Sin CECO")}
                                    </Badge>
                                  </OverlayTrigger>
                                </td>
                                <td className="text-center py-3 px-3">
                                  <div className="d-flex gap-1 justify-content-center">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip>Editar usuario</Tooltip>
                                      }
                                    >
                                      <Button
                                        variant="outline-warning"
                                        size="sm"
                                        onClick={() => {
                                          if (!canEditUsuarios) {
                                            swal.fire("Acceso restringido", "No tiene permisos para editar usuarios.", "warning");
                                            return;
                                          }
                                          setProductoEditar({ ...producto });
                                          setIsModalEditar(true);
                                        }}
                                        disabled={!canEditUsuarios}
                                        style={{
                                          borderRadius: "6px",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        <GrEdit size="12px" />
                                      </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip>Desactivar usuario</Tooltip>
                                      }
                                    >
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={async () => {
                                          if (!canDesactivarUsuarios) {
                                            await swal.fire("Acceso restringido", "No tiene permisos para desactivar usuarios.", "warning");
                                            return;
                                          }
                                          const success = await eliminarUsuario(
                                            producto,
                                            usuario.email,
                                            baseDatos
                                          );
                                          if (success) {
                                            actualizarEstadoProductos(baseDatos, ruc);
                                          }
                                        }}
                                        disabled={!canDesactivarUsuarios}
                                        style={{
                                          borderRadius: "6px",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        <FaBan size="12px" />
                                      </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip>Subir documento</Tooltip>
                                      }
                                    >
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => {
                                          setProductoEditar({ ...producto });
                                          setIsModalUpload(true);
                                        }}
                                        style={{
                                          borderRadius: "6px",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        <FaCloudUploadAlt size="12px" />
                                      </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Resetear contraseña</Tooltip>}
                                    >
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() => resetearClaveUsuario(producto)}
                                        disabled={!canResetearClaveUsuarios}
                                        style={{
                                          borderRadius: "6px",
                                          padding: "4px 8px",
                                        }}
                                      >
                                        <FaKey size="12px" />
                                      </Button>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        {/* ─── Controles de paginación real ─────────────────────────── */}
                        {datosIniciales && (
                          <div className="d-flex justify-content-between align-items-center py-3 px-3" style={{ borderTop: "1px solid #e9ecef" }}>
                            <div className="d-flex align-items-center gap-2">
                              <span className="text-muted" style={{ fontSize: "13px" }}>
                                {tamanioPagina === "todos"
                                  ? `Mostrando todos los ${usuariosPagina.length} usuarios`
                                  : `Mostrando ${usuariosPagina.length} de ${totalUsuarios} usuarios`}
                                {paginaActual > 1 && tamanioPagina !== "todos" && ` (página ${paginaActual})`}
                              </span>
                              <select
                                className="form-select form-select-sm"
                                style={{ width: "auto", fontSize: "13px" }}
                                value={tamanioPagina}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  cambiarTamanioPagina(val === "todos" ? "todos" : Number(val));
                                }}
                              >
                                <option value={10}>10 por página</option>
                                <option value={25}>25 por página</option>
                                <option value={50}>50 por página</option>
                                <option value={100}>100 por página</option>
                                <option value="todos">Todos</option>
                              </select>
                            </div>
                            {tamanioPagina !== "todos" && (
                            <div className="d-flex align-items-center gap-1">
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled={paginaActual <= 1 || cargandoPagina}
                                onClick={() => irAPagina(paginaActual - 1)}
                                style={{ fontSize: "13px", padding: "4px 10px" }}
                              >
                                ← Anterior
                              </Button>
                              <span className="px-2 text-muted" style={{ fontSize: "13px" }}>
                                Página {paginaActual}
                              </span>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled={!hayPaginaSiguiente || cargandoPagina}
                                onClick={() => irAPagina(paginaActual + 1)}
                                style={{ fontSize: "13px", padding: "4px 10px" }}
                              >
                                Siguiente →
                              </Button>
                            </div>
                            )}
                          </div>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                )}

                {/* Barra de acciones mejorada */}
                {datosIniciales && (
                  <Card
                    className="border-0 shadow-sm"
                    style={{ borderRadius: "15px" }}
                  >
                    <Card.Body className="p-4">
                      <Row className="g-3">
                        <Col md={3}>
                          <Button
                            variant="primary"
                            onClick={añadirProductoHome}
                            className="w-100 d-flex align-items-center justify-content-center gap-2 py-3"
                            style={{
                              borderRadius: "10px",
                              background:
                                "linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)",
                              border: "none",
                              boxShadow: "0 4px 8px rgba(59, 130, 246, 0.3)",
                            }}
                          >
                            <FaUserPlus size="16px" />
                            Añadir Usuario
                          </Button>
                        </Col>

                        <Col md={3}>
                          <Button
                            variant="danger"
                            onClick={handleDelete}
                            disabled={selectedRows.length === 0 || !canEliminarMasivoUsuarios}
                            className="w-100 d-flex align-items-center justify-content-center gap-2 py-3"
                            style={{
                              borderRadius: "10px",
                              boxShadow:
                                selectedRows.length > 0
                                  ? "0 4px 8px rgba(220, 38, 38, 0.3)"
                                  : "none",
                            }}
                          >
                            <RiDeleteBin6Fill size="16px" />
                            Eliminar ({selectedRows.length})
                          </Button>
                        </Col>

                        <Col md={3}>
                          <Button
                            variant="success"
                            onClick={() => exportarExcel(getSelectedUsers())}
                            disabled={selectedRows.length === 0}
                            className="w-100 d-flex align-items-center justify-content-center gap-2 py-3"
                            style={{
                              borderRadius: "10px",
                              boxShadow:
                                selectedRows.length > 0
                                  ? "0 4px 8px rgba(34, 197, 94, 0.3)"
                                  : "none",
                            }}
                          >
                            <FaFileExcel size="16px" />
                            Exportar Excel
                          </Button>
                        </Col>

                        <Col md={3}>
                          <Button
                            variant="info"
                            onClick={() =>
                              mostrarModalReporteHandler(getSelectedUsers())
                            }
                            disabled={selectedRows.length === 0}
                            className="w-100 d-flex align-items-center justify-content-center gap-2 py-3 text-white"
                            style={{
                              borderRadius: "10px",
                              boxShadow:
                                selectedRows.length > 0
                                  ? "0 4px 8px rgba(34, 211, 238, 0.3)"
                                  : "none",
                            }}
                          >
                            <FaFilePdf size="16px" />
                            Generar PDF
                          </Button>
                        </Col>

                        {puedeGestionarCampanaClave && (
                          <Col md={3}>
                            <Button
                              variant="warning"
                              onClick={forzarCambioSoloNoLogueados}
                              className="w-100 d-flex align-items-center justify-content-center gap-2 py-3 text-dark"
                              style={{
                                borderRadius: "10px",
                                boxShadow: "0 4px 8px rgba(245, 158, 11, 0.3)",
                              }}
                            >
                              <FaSyncAlt size="16px" />
                              Forzar cambio (no logueados)
                            </Button>
                          </Col>
                        )}
                        {canCargaMasivaUsuarios && (
                          <Col md={3}>
                            <Button
                              variant="outline-primary"
                              onClick={() => navigate("/umasivos")}
                              className="w-100 d-flex align-items-center justify-content-center gap-2 py-3"
                              style={{ borderRadius: "10px" }}
                            >
                              <FaCloudUploadAlt size="16px" />
                              Carga Masiva
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </Card.Body>
                  </Card>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default Usuarios;
